import { useState } from "react";
import AddressWithIcon from "../styles/address-with-icon";
import { ShopLocationType } from "../../../interfaces/delivery-company/pickups";
import { ILocation } from "../../../interfaces/common/location";
import { displayLocation } from "../../../utils/locations";

interface StaticGoogleMapProps {
    mapPath: string;
    url?: string;
    location?: ShopLocationType | ILocation | null;
    noMap?: boolean
}

export default function StaticGoogleMap({ mapPath, url, location, noMap = false }: StaticGoogleMapProps) {
    const [mapError, setMapError] = useState(false);

    // If we have an address but no working map, show AddressWithIcon
    if (((mapPath.length === 0 || mapError) && location) || noMap) {
        return <AddressWithIcon address={location ?? null} />;
    }

    // If no address and no valid map, show nothing
    if (mapPath.length === 0 || mapError) return null;

    return (
        <div style={{
            position: "relative",
            width: "100%",
            borderRadius: '8px',
            overflow: 'hidden'
        }} onClick={(e) => e.stopPropagation()}>
            <iframe
                src={mapPath}
                width="100%"
                style={{
                    border: 0,
                    aspectRatio: '16/9',
                    display: 'block'
                }}
                allowFullScreen
                loading="lazy"
                onError={() => setMapError(true)}
            />

            {/* Address overlay when map is working */}
            {location && (
                <div style={{
                    position: 'absolute',
                    bottom: '8px',
                    left: '8px',
                    right: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    maxWidth: '80%',
                    fontSize: '14px',
                    lineHeight: '1.4',
                    pointerEvents: 'none'
                }}>
                    {displayLocation(location)}
                </div>
            )}

            {/* Click-through overlay */}
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "transparent",
                    zIndex: 1
                }}
            />
        </div>
    );
}